import React, { useRef, useState } from "react";
import { Button, Tooltip, Snackbar, Alert } from "@mui/material";
import { FilePlus } from "lucide-react";
import axios from "axios";

const AddFileButton = ({ userID, onSuccess }) => {
  const fileInputRef = useRef(null);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "success" });

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleSnackClose = () => {
    setSnack({ ...snack, open: false });
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !userID) return;

    const fullUrl = window.location.href;
    const urlPath = new URL(fullUrl).pathname;
    const path = urlPath.includes("/docvault/")
      ? decodeURIComponent(urlPath.split("/docvault/")[1] || "")
      : "";

    try {
      const formData = new FormData();
      formData.append("targetPath", path);
      formData.append("userID", userID);
      formData.append("file", file);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/doc-vault/upload-file`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        setSnack({ open: true, message: "File uploaded successfully!", severity: "success" });
        onSuccess(); // Call the onSuccess callback to refresh the folder structure
      }
    } catch (error) {
      const errMsg = error.response?.data?.message || "Failed to upload file.";
      setSnack({ open: true, message: errMsg, severity: "error" });
    }
  };

  return (
    <div>
      <Tooltip title="Add File" arrow>
        <Button
          variant="outlined"
          color="success"
          size="small"
          sx={{ marginRight: 2 }}
          onClick={handleButtonClick}
        >
          <FilePlus size={25} />
        </Button>
      </Tooltip>

      <input
        type="file"
        onChange={handleUpload}
        ref={fileInputRef}
        className="opacity-0 absolute left-[-10000px]"
      />

      <Snackbar
        open={snack.open}
        autoHideDuration={4000}
        onClose={handleSnackClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snack.severity} onClose={handleSnackClose} sx={{ width: '100%' }}>
          {snack.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AddFileButton;
